<template>
  <div :class="`card bd-none ${bd} ${mgt}`" v-if="dashboardData.rdy">
    <div class="card-header d-flex justify-content-between">
      <h6 class="mg-b-0">Санхүүжилт ШУ салбараар</h6>
      <nav class="nav nav-row-xs align-items-center">
        <a
          @click="
            dashboardData.params.mode = 1;
            loadData();
          "
          :class="`nav-link ${dashboardData.params.mode == 1 ? 'active' : ''}`"
          role="button"
          >1D</a
        >
        <a
          @click="
            dashboardData.params.mode = 2;
            loadData();
          "
          :class="`nav-link ${dashboardData.params.mode == 2 ? 'active' : ''}`"
          role="button"
          >1W</a
        >
        <a
          @click="
            dashboardData.params.mode = 3;
            loadData();
          "
          :class="`nav-link ${dashboardData.params.mode == 3 ? 'active' : ''}`"
          role="button"
          >1M</a
        >
        <a
          @click="
            dashboardData.params.mode = 4;
            loadData();
          "
          :class="`nav-link ${dashboardData.params.mode == 4 ? 'active' : ''}`"
          role="button"
          >1Y</a
        >
        <a
          @click="
            dashboardData.params.mode = 5;
            loadData();
          "
          :class="`nav-link ${dashboardData.params.mode == 5 ? 'active' : ''}`"
          role="button"
          >ALL</a
        >
      </nav>
    </div>

    <div class="card-body pd-0">
      <div class="row mg-b-20">
        <div class="col text-center">
          <h4 class="tx-normal tx-rubik tx-spacing--1 mg-b-10">
            {{
              dashboardData.data.list.filter((x) => x.typeId == 0).reduce((sum, { count }) => sum + parseInt(count), 0) | formatMoney(0, ".", ",")
            }} ₮
            <!-- 150,200  -->
            <!-- <small class="tx-11 tx-success letter-spacing--2"><i class="icon ion-md-arrow-up"></i> 0.20%</small> -->
          </h4>
          <p class="tx-11 tx-uppercase tx-spacing-1 tx-medium tx-color-03">
            Батлаагүй
          </p>
        </div>
        <div class="col  text-center">
          <h4 class="tx-normal tx-rubik tx-spacing--1 mg-b-10">
            {{
              dashboardData.data.list
                .filter((x) => x.typeId == 1)
                .reduce((sum, { count }) => sum + parseInt(count), 0)  | formatMoney(0, ".", ",")
            }} ₮
            <!-- 21,880  -->
            <!-- <small class="tx-11 tx-danger letter-spacing--2"><i class="icon ion-md-arrow-down"></i> 1.04%</small>-->
          </h4>
          <p class="tx-11 tx-uppercase tx-spacing-1 tx-medium tx-color-03">
            Баталсан
          </p>
        </div>
      </div>
      <!-- {{ dashboardData.data.list }} -->
      <div>
        <apexchart
          type="bar"
          height="250"
          :options="dashboardData.chart.options"
          :series="dashboardData.chart.series"
          :key="dashboardData.chart.key"
        ></apexchart>
      </div>
    </div>
    <div class="card-footer tx-11 tx-color-03">
      <div>
        Хамрах хугацаа:
        {{ dashboardData.data.processed.startDate | moment("YYYY.MM.DD") }}
        -
        {{ dashboardData.data.processed.endDate | moment("YYYY.MM.DD") }}<br />
        Боловсруулсан:
        {{ dashboardData.data.processed.time.toFixed(2) }}сек
      </div>
    </div>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import VueApexCharts from "vue-apexcharts";
import { request } from "@/api/all";
const moment = require("moment");

export default {
  components: {
    apexchart: VueApexCharts,
    mainHeader: () => ({
      component: import("@/views/apps/penalty/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  props: {
    mgt: {
      type: String,
      default: () => "",
    },
    bd: {
      type: String,
      default: () => "",
    },
  },
  data() {
    return {
      dashboardData: {
        chart: {
          key: 0,
          series: [
            {
              name: "Нийт",
              data: [],
            },
            {
              name: "Баталсан",
              data: [],
            },
          ],
          options: {
            chart: {
              height: 150,
              type: "line",
              zoom: {
                enabled: false,
              },
            },
            dataLabels: {
              enabled: false,
            },
            stroke: {
              curve: "straight",
            },
            grid: {
              row: {
                colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
                opacity: 0.5,
              },
            },
            xaxis: {
              categories: [],
            },
          },
        },
        rdy: false,
        params: {
          mode: 5,
          startDate: moment()
            .startOf("month")
            .format("YYYY-MM-DD"),
          endDate: moment().format("YYYY-MM-DD"),
        },
        data: {
          list: [],
        },
      },
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    loadData() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "projectEdu/ProjectFinanceGroupBySalbar" },
        params: {
          mode: this.dashboardData.params.mode,
          startDate: this.dashboardData.params.startDate,
          endDate: this.dashboardData.params.endDate,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          console.log('ProjectFinanceGroupBySalbar', res);
          this.dashboardData.data = res.data;
          //
          this.dashboardData.chart.series[0].data = this.dashboardData.data.list
            .filter((x) => x.typeId == 0)
            .map((x) => {
              return x.count;
            });
          this.dashboardData.chart.series[1].data = this.dashboardData.data.list
            .filter((x) => x.typeId == 1)
            .map((x) => {
              return x.count;
            });
          this.dashboardData.chart.options.xaxis.categories = this.dashboardData.data.gates.map(
            (x) => {
              return x.name;
            }
          );
          this.dashboardData.chart.key++;
          this.dashboardData.rdy = true;
        }
      });
    },
  },
};
</script>
